export default "__VITE_PUBLIC_ASSET__29e0cf98__"